import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

export const CONTACT_POINT_KIND = {
  PHONE: "phone",
  MOBILE: "mobile",
  FAX: "fax",
  EMAIL: "email",
};

const KIND_ICONS = {
  [CONTACT_POINT_KIND.PHONE]: "fa-phone",
  [CONTACT_POINT_KIND.MOBILE]: "fa-mobile-screen-button",
  [CONTACT_POINT_KIND.FAX]: "fa-fax",
  [CONTACT_POINT_KIND.EMAIL]: "fa-envelope",
};

const pointShape = PropTypes.shape({
  kind: PropTypes.oneOf(Object.values(CONTACT_POINT_KIND)).isRequired,
  value: PropTypes.string.isRequired,
  display: PropTypes.string,
  href: PropTypes.string,
  label: PropTypes.string,
});

const contactShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  role: PropTypes.string,
  note: PropTypes.string,
  points: PropTypes.arrayOf(pointShape),
});

function ContactPointItem({ point }) {
  const { t } = useTranslation();
  const kindLabel = t(`contacts.kinds.${point.kind}`);
  const text = point.display || point.value;

  return (
    <li>
      <i className={`fa fa-fw ${KIND_ICONS[point.kind]} text-muted me-1`} title={kindLabel} aria-hidden="true" />
      <span className="visually-hidden">{kindLabel}: </span>
      {point.href ? <a href={point.href}>{text}</a> : text}
      {!!point.label && <span className="text-muted ms-1">({point.label})</span>}
    </li>
  );
}

ContactPointItem.propTypes = {
  point: pointShape.isRequired,
};

function ContactList({ contacts = [] }) {
  if (contacts.length === 0) {
    return null;
  }

  return (
    <ul className="list-group list-unstyled">
      {contacts.map((contact, index) => (
        <li key={`${index}-${contact.name}`} className="mt-2">
          <ul className="list-group list-unstyled">
            {!!contact.role && <li className="text-muted small">{contact.role}</li>}
            <li>{contact.name}</li>
            {!!contact.note && <li className="text-muted small">{contact.note}</li>}
            {(contact.points || []).map((point, pointIndex) => (
              <ContactPointItem key={`${pointIndex}-${point.value}`} point={point} />
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
}

ContactList.propTypes = {
  contacts: PropTypes.arrayOf(contactShape),
};

export default ContactList;
